import { css } from "@emotion/react";

export const HeaderStyle = {
  index: css`
    background: rgba(17, 17, 17, 1);
  `,
  content: css`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding: 0 20px;

    .menu-click {
    }
    .logo {
      img {
        width: 90px;
        height: 42px;
      }
    }
  `,
};
